<template>
	<time :time="value">
		<template v-if="date">{{ aMoment | dateFormat(format) }}</template>
		<template v-else>{{ aMoment | dateTimeFormat(format) }}</template>
	</time>
</template>

<script>
export default
{
	props:
	{
		value:
		{
			required: true,
		},

		date:
		{
			type:    Boolean,
			default: true,
		},

		format:
		{
			type: String,
		},
	},

	computed:
	{
		aMoment()
		{
			return this.value && this.moment(this.value)
		},

		isValid()
		{
			return this.aMoment && this.aMoment.isValid()
		},
	},
}
</script>